import React, { useEffect, useState } from "react";
import OnboardingHeader from "../../Onboarding/OnboardingHeader";
import "./ProfileUnderReview.css";
import Icons from "../../../../../Config/Images";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import { onVerificationPending } from "../../../../../Store/Slice/authSlice";
import HeaderBlack from "../../../WelcomeScreen/Common/Header";
import Footer from "../../../Layout/Footer/Footer";

const ProfileUnderReview = () => {
  const [timeLeft, setTimeLeft] = useState(null); // Timer for 15 minutes

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const fromOnboardingSubmitButton =
    location?.state?.fromOnboardingSubmitButton;
  const loggedInUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (fromOnboardingSubmitButton) {
      localStorage.removeItem("userId");
      localStorage.removeItem("startTime");
    }
  }, [fromOnboardingSubmitButton]);

  // useEffect(() => {
  //   if (startTimer && timeLeft >= 0) {
  //     const timer = setInterval(() => {
  //       setTimeLeft((prevTime) => {
  //         if (prevTime <= 1) {
  //           clearInterval(timer);
  //           dispatch(onVerificationPending());

  //           // Navigate to profile-pending & block back button
  //           navigate("/profile-pending", { replace: true });
  //           blockBackNavigation();

  //           return 0;
  //         }
  //         return prevTime - 1;
  //       });
  //     }, 1000);

  //     return () => clearInterval(timer);
  //   }
  // }, [startTimer, timeLeft, navigate, dispatch]);

  // Function to block back navigation on profile-pending page
  const blockBackNavigation = () => {
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", preventBack);
  };

  // Prevent back navigation
  const preventBack = () => {
    if (window.location.pathname === "/profile-pending") {
      window.history.pushState(null, "", window.location.href);
    } else {
      window.removeEventListener("popstate", preventBack);
    }
  };

  // Cleanup when user navigates away from "/profile-pending"
  useEffect(() => {
    if (location.pathname !== "/profile-pending") {
      window.removeEventListener("popstate", preventBack);
    }
  }, [location.pathname]);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        console.log("FULL API RESULT 👉", result);
        const user = result?.data?.[0];

        console.log("USER OBJECT 👉", user);
        console.log("user_status_name 👉", user?.user_status_name);
        console.log("updated_at_timestamp 👉", user?.updated_at_timestamp);
        const userStatus = result?.data?.[0]?.user_status_name;
        const updatedAtTimestamp = result?.data?.[0]?.updated_at_timestamp;
        // Log the updated_at_timestamp to ensure it’s in the correct format

        // Check if the timestamp is valid
        const updatedTime = new Date(updatedAtTimestamp);

        // If the updatedTime is invalid, log and exit early
        if (isNaN(updatedTime)) {
          console.log("Invalid Date format detected!");
          return; // Exit if the date is invalid
        }

        const currentTime = new Date();
        const timeDifference = currentTime - updatedTime;

        console.log("Parsed updatedTime 👉", updatedTime);
        console.log("CurrentTime 👉", currentTime);
        console.log("Diff in minutes 👉", (currentTime - updatedTime) / 60000);

        // Check if it's within 15 minutes (900,000 milliseconds)
        if (timeDifference <= 15 * 60 * 1000) {
          console.log("logged inside if condition");
          // User is within the 15-minute window, calculate the time left
          const remainingTime = 15 * 60 * 1000 - timeDifference;
          setTimeLeft(remainingTime); // Set the timeLeft state
          console.log("Timer started with ms 👉", remainingTime);
          console.log("Timer started with min 👉", remainingTime / 60000);

          // User is within the 15-minute window
          if (userStatus === "rejected") {
            navigate("/profile-not-approved", { replace: true });
            localStorage.removeItem("isRefillingOnboardingFormIsNowInReviewed");
          } else if (userStatus === "approved") {
            navigate("/profile-verified", { replace: true });
            localStorage.removeItem("isRefillingOnboardingFormIsNowInReviewed");
          }
        } else {
          console.log("logged inside else condition");
          navigate("/profile-pending", { replace: true }); // Redirect to /profile-pending when time is over
        }
      })
    );
  }, [dispatch, navigate]);

  // Countdown timer logic
  useEffect(() => {
    if (timeLeft !== null && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTimeLeft) => prevTimeLeft - 1000); // Decrease timeLeft every second
      }, 1000);

      return () => clearInterval(timer); // Cleanup the timer when component unmounts
    }
  }, [timeLeft]);
  useEffect(() => {
    console.log("timeLeft updated 👉", timeLeft);
  }, [timeLeft]);

  // Format the time left in minutes and seconds
  const formatTime = (timeInMillis) => {
    const minutes = Math.floor(timeInMillis / 60000);
    const seconds = Math.floor((timeInMillis % 60000) / 1000);

    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  return (
    <>
      {/* <OnboardingHeader /> */}
      <div style={{ position: "sticky", top: 0 }}>
        <div className="section-1-div">
          <HeaderBlack noLoginBtn={true} />
        </div>
      </div>
      <div
        className="profile-under-review-under-review"
        style={{
          backgroundImage: `url(${Icons.loginBgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        <div className="under-review-profile-review-card">
          <div className="profile-review-image">
            <img
              src={Icons.under_review_image}
              alt="Profile Under Review Image"
            />
          </div>
          <div className="profile-review-card-content">
            <div className="under-review-timer">
              <span>{timeLeft > 0 ? formatTime(timeLeft) : "00:00"} Min.</span>
              {/* <span>time</span> */}
            </div>
            <h3 className="under-review-heading">Profile Under Review</h3>
            <p className="under-review-description">
              Your profile is currently under review. This process helps us
              ensure the accuracy and security of your information.
            </p>
            <ul className="under-review-review-steps">
              <li>We’ll verify your details.</li>
              <li>
                You will receive a notification once your profile is approved.
              </li>
            </ul>
            <button
              onClick={() => navigate("/", { state: { showLoginBtn: true } })}
              className="under-review-thank-you-button"
            >
              Thank You
            </button>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default ProfileUnderReview;
